import { ContextError } from '@lingoda/errors';
import type { MercureMessage, MercureMessageData } from './types';

export const getMercureMessageData = (msg: MercureMessage) => {
    const data: MercureMessageData = JSON.parse(msg.data);
    if (typeof data !== 'object' || data === null) {
        throw new ContextError(`'data' should be object, received \`${typeof data}\``, {
            context: {
                message: { ...msg },
            },
        });
    }

    const summary = JSON.parse(data.summary);
    if (typeof summary !== 'object' || summary === null) {
        throw new ContextError(`'summary' should be object, received \`${typeof summary}\``, {
            context: {
                data: { summary: data.summary },
            },
        });
    }

    return summary;
};
